"use client";
import * as E from "react";
import { j as A } from "./jsx-runtime-CJ-St4mQ.mjs";
const C = {};
function O(e, n) {
  const t = E.useRef(C);
  return t.current === C && (t.current = e(n)), t;
}
function N(e, n, t, c) {
  const r = O(S).current;
  return k(r, e, n, t, c) && h(r, [e, n, t, c]), r.callback;
}
function R(e) {
  const n = O(S).current;
  return L(n, e) && h(n, e), n.callback;
}
function S() {
  return {
    callback: null,
    cleanup: null,
    refs: []
  };
}
function k(e, n, t, c, r) {
  return e.refs[0] !== n || e.refs[1] !== t || e.refs[2] !== c || e.refs[3] !== r;
}
function L(e, n) {
  return e.refs.length !== n.length || e.refs.some((t, c) => t !== n[c]);
}
function h(e, n) {
  if (e.refs = n, n.every((t) => t == null)) {
    e.callback = null;
    return;
  }
  e.callback = (t) => {
    if (e.cleanup && (e.cleanup(), e.cleanup = null), t != null) {
      const c = Array(n.length).fill(null);
      for (let r = 0; r < n.length; r += 1) {
        const u = n[r];
        if (u != null)
          switch (typeof u) {
            case "function": {
              const i = u(t);
              typeof i == "function" && (c[r] = i);
              break;
            }
            case "object": {
              u.current = t;
              break;
            }
          }
      }
      e.cleanup = () => {
        for (let r = 0; r < n.length; r += 1) {
          const u = n[r];
          if (u != null)
            switch (typeof u) {
              case "function": {
                const i = c[r];
                typeof i == "function" ? i() : u(null);
                break;
              }
              case "object": {
                u.current = null;
                break;
              }
            }
        }
      };
    }
  };
}
const D = parseInt(E.version, 10);
function j(e) {
  return D >= e;
}
function P(e, n) {
  if (e && !n)
    return e;
  if (!e && n)
    return n;
  if (e || n)
    return {
      ...e,
      ...n
    };
}
function v(e, n) {
  const t = {};
  for (const c in e) {
    const r = e[c];
    if (n != null && n.hasOwnProperty(c)) {
      const u = n[c](r);
      u != null && Object.assign(t, u);
      continue;
    }
    r === !0 ? t[`data-${c.toLowerCase()}`] = "" : r && (t[`data-${c.toLowerCase()}`] = r.toString());
  }
  return t;
}
function w(e, n) {
  return typeof e == "function" ? e(n) : e;
}
const a = {};
function U(e, n, t, c, r) {
  let u = {
    ...y(e, a)
  };
  return n && (u = l(u, n)), t && (u = l(u, t)), c && (u = l(u, c)), r && (u = l(u, r)), u;
}
function x(e) {
  if (e.length === 0)
    return a;
  if (e.length === 1)
    return y(e[0], a);
  let n = {
    ...y(e[0], a)
  };
  for (let t = 1; t < e.length; t += 1)
    n = l(n, e[t]);
  return n;
}
function l(e, n) {
  return m(n) ? n(e) : Y(e, n);
}
function Y(e, n) {
  if (!n)
    return e;
  for (const t in n) {
    const c = n[t];
    switch (t) {
      case "style": {
        e[t] = P(e.style, c);
        break;
      }
      case "className": {
        e[t] = T(e.className, c);
        break;
      }
      default:
        p(t, c) ? e[t] = V(e[t], c) : e[t] = c;
    }
  }
  return e;
}
function p(e, n) {
  const t = e.charCodeAt(0), c = e.charCodeAt(1), r = e.charCodeAt(2);
  return t === 111 && c === 110 && r >= 65 && r <= 90 && (typeof n == "function" || typeof n > "u");
}
function m(e) {
  return typeof e == "function";
}
function y(e, n) {
  return m(e) ? e(n) : e ?? a;
}
function V(e, n) {
  return n ? e ? (t) => {
    if (G(t)) {
      const r = t;
      B(r);
      const u = n(r);
      return r.baseUIHandlerPrevented || e == null || e(r), u;
    }
    const c = n(t);
    return e == null || e(t), c;
  } : n : e;
}
function B(e) {
  return e.preventBaseUIHandler = () => {
    e.baseUIHandlerPrevented = !0;
  }, e;
}
function T(e, n) {
  return n ? e ? n + " " + e : n : e;
}
function G(e) {
  return e != null && typeof e == "object" && "nativeEvent" in e;
}
const $ = 500, J = 500, Z = {
  style: {
    transition: "none"
  }
}, s = {}, q = [], z = "data-base-ui-click-trigger", Q = {
  fallbackAxisSide: "none"
}, X = {
  fallbackAxisSide: "end"
};
function H(e, n, t = {}) {
  const c = n.render, r = M(n, t);
  if (t.enabled === !1)
    return null;
  const u = t.state ?? s;
  return F(e, c, r, u);
}
function M(e, n = {}) {
  const {
    className: t,
    render: c
  } = e, {
    state: r = s,
    ref: u,
    props: i,
    disableStyleHooks: _,
    customStyleHookMapping: I,
    enabled: o = !0
  } = n, b = o ? w(t, r) : void 0;
  let d;
  _ !== !0 && (d = E.useMemo(() => o ? v(r, I) : s, [r, I, o]));
  const f = o ? P(d, Array.isArray(i) ? x(i) : i) ?? s : s;
  return typeof document < "u" && (o ? Array.isArray(u) ? f.ref = R([f.ref, g(c), ...u]) : f.ref = N(f.ref, g(c), u) : N(null, null)), o ? (b !== void 0 && (f.className = T(f.className, b)), f) : s;
}
function F(e, n, t, c) {
  if (n) {
    if (typeof n == "function")
      return n(t, c);
    const r = U(t, n.props);
    return r.ref = t.ref, /* @__PURE__ */ E.cloneElement(n, r);
  }
  if (e && typeof e == "string")
    return K(e, t);
  throw new Error("Base UI: Render element or function are not defined.");
}
function K(e, n) {
  return e === "button" ? /* @__PURE__ */ A.jsx("button", {
    type: "button",
    ...n
  }) : e === "img" ? /* @__PURE__ */ A.jsx("img", {
    alt: "",
    ...n
  }) : /* @__PURE__ */ E.createElement(e, n);
}
function g(e) {
  return e && typeof e != "function" ? j(19) ? e.props.ref : e.ref : null;
}
export {
  z as C,
  Q as D,
  s as E,
  J as P,
  $ as T,
  O as a,
  q as b,
  N as c,
  B as d,
  X as e,
  Z as f,
  j as i,
  U as m,
  H as u
};
